import React from "react";
import PropTypes from "prop-types";
import {
  Table,
  Divider,
  Input,
  Button,
  Tooltip,
  Select,
  Popconfirm,
} from "antd";
import {
  SearchOutlined,
  PlusCircleOutlined,
  EditOutlined,
  FileTextOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import {
  defaultSort,
  getTablePagesize,
  selectFilterFunction,
  setTablePageSize,
} from "../../../Constants/Utilities";
import { StatusSwitch } from "../../Common/StatusSwitch";
import {
  ConfigActions,
  EntityStatus,
  StatusFilters,
  TablePages,
  TablePageSizes,
} from "../../../Constants/Constants";
import { BreadCrumbs } from "../../Common/BreadCrumbs";

class ListDeviceModelConfig extends React.Component {
  constructor(props) {
    super(props);
    console.log("ListDeviceModelConfig props", props);
    this.state = {
      modelConfigData: props.modelConfigData,
    };
  }

  componentDidUpdate(prevProps) {
    const { modelData, modelConfigData } = this.props;
    if (
      prevProps.modelData !== modelData ||
      prevProps.modelConfigData !== modelConfigData
    ) {
      this.setState({ modelData, modelConfigData });
    }
  }

  getColumns = () => [
    {
      title: "Configuration Name",
      dataIndex: "name",
      sorter: (a, b) => defaultSort(a.name, b.name),
      defaultSortOrder: "ascend",
      render: (value, record) => (
        <Button
          type="link"
          onClick={this.props.onActionClick(ConfigActions.view, record)}
        >
          {value}
        </Button>
      ),
    },
    {
      title: "Active",
      dataIndex: "status",
      align: "center",
      filters: StatusFilters,
      onFilter: (value, record) => record.status === value,
      render: StatusSwitch(this.props.onStatusChange),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      align: "center",
      render: (_, record) => (
        <div className="entity-list-actions">
          <Tooltip title="View Config">
            <FileTextOutlined
              className="entity-action"
              onClick={this.props.onActionClick(ConfigActions.view, record)}
            />
          </Tooltip>
          <Tooltip title="Edit Config">
            <EditOutlined
              onClick={this.props.onActionClick(ConfigActions.edit, record)}
            />
          </Tooltip>
          {record.status === EntityStatus.INACTIVE && (
            <Tooltip title="Delete Config">
              <Popconfirm
                okText="Yes"
                cancelText="No"
                title="Are you sure want to Delete Config?"
                onConfirm={() => this.props.deleteGroupConfig(record)}
              >
                <DeleteOutlined />
              </Popconfirm>
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  onSerchTextChange = (e) => {
    const text = e.target.value;
    const { modelConfigData } = this.props;
    if (!!text) {
      const filteredData = modelConfigData.filter((item) =>
        item.name.toLowerCase().includes(text.toLowerCase())
      );
      this.setState({ modelConfigData: filteredData });
      return;
    }
    this.setState({ modelConfigData });
  };

  render() {
    const { modelConfigData } = this.state;
    const {
      modelData,
      modelDataLoading,
      onActionClick,
      selectedModel,
      onModelSelect,
      modelConfigDataLoading,
      deleteConfigLoading,
      parentBread,
    } = this.props;

    return (
      <div className="entity-list-container">
        <div className="page-header-container">
          <BreadCrumbs headers={parentBread} />
        </div>
        <Divider className="divider" />
        <div className="entity-selection-container">
          <span className="entity-label">Device Model:</span>
          <Select
            showSearch
            allowClear
            value={selectedModel}
            loading={modelDataLoading}
            disabled={modelDataLoading}
            onChange={onModelSelect}
            filterOption={selectFilterFunction}
            style={{ minWidth: "250px", maxWidth: "300px" }}
            placeholder={
              modelDataLoading
                ? "Loading Device Models..."
                : "Select Device Model"
            }
          >
            {modelData?.map((item) => (
              <Select.Option key={item.modelId} title={item.modelNumber}>
                {item.modelNumber}
              </Select.Option>
            ))}
          </Select>
        </div>
        <Divider className="divider" />
        <div className="search-add-container">
          <div className="search-container">
            <span className="search-label">Search:</span>
            <Input
              allowClear
              className="search-input"
              placeholder="Enter Config Name"
              onChange={this.onSerchTextChange}
              disabled={!selectedModel}
              suffix={<SearchOutlined style={{ fontSize: 16 }} />}
            />
          </div>
          <div className="add-container">
            <Button
              type="primary"
              icon={<PlusCircleOutlined />}
              onClick={onActionClick(ConfigActions.add, null)}
            >
              Add Configuration
            </Button>
          </div>
        </div>
        {!selectedModel ? (
          <div className="no-entity-warning">
            <div className="warning-label">
              Select any Device Model to view configurations
            </div>
          </div>
        ) : (
          <Table
            bordered
            size="small"
            columns={this.getColumns()}
            className="entity-table"
            loading={
              modelConfigDataLoading ||
              (deleteConfigLoading && {
                tip: "Fetching Configurations...",
              })
            }
            dataSource={modelConfigData}
            pagination={{
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              defaultPageSize: getTablePagesize(
                TablePages.listDeviceModelConfig
              ),
              pageSizeOptions: TablePageSizes,
              onChange: (_, pageSize) =>
                setTablePageSize(TablePages.listDeviceModelConfig, pageSize),
            }}
          />
        )}
      </div>
    );
  }
}

ListDeviceModelConfig.propTypes = {
  modelData: PropTypes.array,
  modelDataLoading: PropTypes.bool,
  deleteConfigLoading: PropTypes.bool,
  selectedModel: PropTypes.string,
  modelConfigData: PropTypes.array,
  modelConfigDataLoading: PropTypes.bool,
  onModelSelect: PropTypes.func,
  onActionClick: PropTypes.func,
  onStatusChange: PropTypes.func,
};

export default ListDeviceModelConfig;
